var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoAccent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 0C4.92529 0 0 4.92707 0 11C0 17.0765 4.92529 22 11 22C17.0747 22 22 17.0765 22 11C22 4.92707 17.0747 0 11 0ZM10 9C10 8.44771 10.4477 8 11 8C11.5523 8 12 8.44771 12 9V16C12 16.5523 11.5523 17 11 17C10.4477 17 10 16.5523 10 16V9ZM11 5C10.4477 5 10 5.44772 10 6C10 6.55228 10.4477 7 11 7C11.5523 7 12 6.55228 12 6C12 5.44772 11.5523 5 11 5Z",
    fill: "#7239FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoAccent);
export default __webpack_public_path__ + "static/media/info-accent.4e054a97367833e7cfea03cd42903121.svg";
export { ForwardRef as ReactComponent };